export default {
    statisticSurveyBaseData: 'Daten',
    statisticSurveyPeriods: 'Erhebungszeiträume',
    statisticSurveyActivities: 'Historie',
}